import { EntryEditButtonGroup } from '@/scenes/Blog/EntryEdit/EntryEditButtonGroup';
import { useEntryEditContext } from '@/scenes/Blog/EntryEdit/EntryEditContext';
import processHtmlToReact from '@/utils/helpers/processHtml';
import moment from 'moment';

export function PreviewEntry({ eid, onPublish, onDelete }) {
  const { previewContent, entryTitle, tags, setPreview } =
    useEntryEditContext();

  return (
    <div
      className={`blog-entry blog-entry--no-author blog-entry--no-blog-link`}
    >
      <div className="blog-entry-meta--up ">
        <div className="blog-entry-date">
          {moment().format('HH:mm DD.MM.YYYY')}
        </div>
        <div
          className={`blog-entry-title ${
            entryTitle ? '' : 'blog-entry--no-title'
          }`}
        >
          {entryTitle}
        </div>
      </div>

      <div className="blog-entry-content">
        {processHtmlToReact(previewContent)}
      </div>

      {tags?.length > 0 && (
        <div className="blog-entry-tags">
          {tags.map(tag => (
            <span key={tag}>#{tag}</span>
          ))}
        </div>
      )}

      <EntryEditButtonGroup
        onPublish={() => onPublish(previewContent)}
        onTogglePreview={() => setPreview(false)}
        onDelete={onDelete}
        eid={eid}
      />
    </div>
  );
}
